
import alert from '~/components/alert'
export default {
  data() {
    return {
      api: process.env.API,
      listkhachhang: [],
      selectedPid: null,
      selectedKhachHang: null,
      refreshToken: '',
      accessToken: '',
      headers: null,
      alert: {
        visible: false,
        message: '',
        type: '',
        duration: '',
      },
      scheduleStatus: null,
      step: 'phone',
      phone: '',
      otp: '',
      password: '',
      confirmPassword: '',
      cards: [
        { icon: '/slide/group-47.png', title: 'Khám sức khỏe \ndoanh nghiệp' },
        {
          icon: '/slide/group-27.png',
          title: 'Kiểm tra khám sức khỏe theo mô hình chuyên sâu',
        },
        {
          icon: '/slide/group-46.png',
          title: 'Hổ trợ khám và điều trị kết hợp theo yêu cầu',
        },
        {
          icon: '/slide/group-48.png',
          title: 'Tham vấn ý kiến y tế thứ hai (Second Opinion)',
        },
        {
          icon: '/slide/vector.png',
          title: 'Khám bệnh, tầm soát ung bướu đột quỵ theo yêu cầu',
        },
        // ...
      ],
    }
  },
  watch: {
    step(newVal) {
      if (newVal === 'setpass') {
        this.$nextTick(() => {
          // focus vào input khi DOM render xong
          this.$refs.passwordInput?.focus()
        })
      }
    },
  },
  computed: {
    groupedCards() {
      const perGroup = 5 // số lượng card mỗi nhóm (slide)
      const groups = []
      for (let i = 0; i < this.cards.length; i += perGroup) {
        groups.push(this.cards.slice(i, i + perGroup))
      }
      return groups
    },
  },
  mounted() {
    // document.body.style.zoom = '75%'
    const savedPhone = this.getItemWithExpire('phone')
    const savedList = this.getItemWithExpire('listkhachhang')

    if (savedPhone && savedList) {
      this.phone = savedPhone
      this.listkhachhang = savedList

      if (this.listkhachhang.length > 1) {
        this.step = 'chonpid'
      } else {
        this.selectedPid = this.listkhachhang?.pid
        this.$store.commit('setMayte', this.listkhachhang.mayte)
        this.$router.push('/')
      }
    }

    // Load schedule status
    this.loadScheduleStatus()
  },
  methods: {
    generateRandomString(length) {
      const characters =
        'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789_'
      let randomString = ''
      for (let i = 0; i < length; i++) {
        randomString += characters.charAt(
          Math.floor(Math.random() * characters.length)
        )
      }
      return randomString
    },
    async quenMatKhau() {
      if (!this.phone) {
        this.alert.visible = true
        this.alert.message = 'Không tìm thấy thông tin khách hàng.'
        this.alert.type = 'error'
        this.alert.duration = 2000
        setTimeout(() => {
          this.alert.visible = false
          this.alert.message = ''
          this.alert.type = ''
        }, this.alert.duration)
        return
      }
      const headers = this.headers
      try {
        const phoneOtp = await this.$axios.post(
          `/insert_phone_otp`,
          {
            p_phone: this.phone,
          },
          {
            headers: {
              authorization: headers.authorization,
            },
          }
        )
        if (phoneOtp.data.success) {
          // TODO: gửi OTP về số điện thoại bằng SMS nếu có
          // Chuyển sang bước nhập OTP
          this.step = 'otp'
          this.alert.visible = true
          this.alert.message =
            'Đã gửi lại mã OTP về số điện thoại của khách hàng.'
          this.alert.type = 'success'
          this.alert.duration = 10000
          setTimeout(() => {
            this.alert.visible = false
            this.alert.message = ''
            this.alert.type = ''
          }, this.alert.duration)
        } else {
          this.alert.visible = true
          this.alert.message = 'lỗi otp'
          this.alert.type = 'error'
          this.alert.duration = 2000
          setTimeout(() => {
            this.alert.visible = false
            this.alert.message = ''
            this.alert.type = ''
          }, this.alert.duration)
        }
      } catch (err) {
        console.error(err)
        this.alert.visible = true
        this.alert.message = 'Không thể xử lý yêu cầu quên mật khẩu.'
        this.alert.type = 'error'
        this.alert.duration = 2000
        setTimeout(() => {
          this.alert.visible = false
          this.alert.message = ''
          this.alert.type = ''
        }, this.alert.duration)
      }
    },
    validatePhone(value) {
      const regex = /^(0|\+84)([0-9]{9})$/ // 10 số, bắt đầu 0 hoặc +84
      return regex.test(value)
    },
    async traCuu() {
      if (!this.phone) {
        this.alert.visible = true
        this.alert.message = 'Vui lòng nhập số điện thoại'
        this.alert.type = 'error'
        this.alert.duration = 2000
        setTimeout(() => {
          this.alert.visible = false
          this.alert.message = ''
          this.alert.type = ''
        }, this.alert.duration)

        return
      }
      if (this.validatePhone(this.phone) === true) {
        try {
          const getToken = await this.$axios.$post('/getToken')

          this.refreshToken = getToken.refreshToken
          this.accessToken = getToken.accessToken
          localStorage.setItem('accessToken', this.accessToken)
          localStorage.setItem('refreshToken', this.refreshToken)

          this.headers = { authorization: localStorage.getItem('accessToken') }
          const headers = this.headers
          // console.log(this.headers)
          const checkPhone = await this.$axios.post(
            `/check_phone_person`,
            {
              p_phone: this.phone,
            },
            {
              headers: {
                authorization: headers.authorization,
              },
            }
          )
          //console.log(checkPhone.data)

          if (checkPhone.data.data[0].check_phone_person) {
            // Gọi API tra cứu khách hàng theo số điện thoại
            const checkPass = await this.$axios.get(
              `/check_hosoonline_password`,
              {
                headers,
                params: { p_phone: this.phone },
              }
            )

            if (checkPass.data.data && checkPass.data.data.length > 0) {
              this.step = 'dangnhap'
            } else {
              const phoneOtp = await this.$axios.post(
                `/insert_phone_otp`,
                {
                  p_phone: this.phone,
                },
                {
                  headers: {
                    authorization: headers.authorization,
                  },
                }
              )
              if (phoneOtp.data.success) {
                // TODO: gửi OTP về số điện thoại bằng SMS nếu có
                // Chuyển sang bước nhập OTP
                this.step = 'otp'
              } else {
                this.alert.visible = true
                this.alert.message = 'lỗi otp'
                this.alert.type = 'error'
                this.alert.duration = 2000
                setTimeout(() => {
                  this.alert.visible = false
                  this.alert.message = ''
                  this.alert.type = ''
                }, this.alert.duration)
              }
            }
          } else {
            this.alert.visible = true
            this.alert.message = 'SĐT chưa được đăng ký'
            this.alert.type = 'error'
            this.alert.duration = 2000
            setTimeout(() => {
              this.alert.visible = false
              this.alert.message = ''
              this.alert.type = ''
            }, this.alert.duration)
          }
        } catch (error) {
          console.error(error)
          console.log(error)

          this.alert.visible = true
          this.alert.message = 'Có lỗi xảy ra khi tra cứu'
          this.alert.type = 'error'
          this.alert.duration = 2000
          setTimeout(() => {
            this.alert.visible = false
            this.alert.message = ''
            this.alert.type = ''
          }, this.alert.duration)
        }
      } else {
        this.alert.visible = true
        this.alert.message = 'SĐT không hợp lệ'
        this.alert.type = 'error'
        this.alert.duration = 2000
        setTimeout(() => {
          this.alert.visible = false
          this.alert.message = ''
          this.alert.type = ''
        }, this.alert.duration)
      }
    },
    chonKhachHang() {
      const selected = this.listkhachhang?.find(
        (kh) => kh.pid === this.selectedPid
      )

      if (selected) {
        this.selectedKhachHang = selected
        this.selectedPid = this.listkhachhang?.pid
        // console.log('đã chọn ', this.listkhachhang.mayte)
        this.$store.commit('setMayte', selected.mayte)
        // localStorage.setItem('listkhachhang', JSON.stringify([selected]))

        this.$router.push('/main')
        //this.step = 'otp'
      }
    },
    async xacThucOtp() {
      try {
        const headers = this.headers
        const result = await this.$axios.get(`/check_phone_otp`, {
          headers,
          params: { p_phone: this.phone },
        })

        const otpServer = result.data.data[0]?.matkhau

        if (this.otp === otpServer) {
          this.step = 'setpass'
        } else {
          this.alert.visible = true
          this.alert.message = 'Mã OTP không đúng'
          this.alert.type = 'error'
          this.alert.duration = 2000
          setTimeout(() => {
            this.alert.visible = false
            this.alert.message = ''
            this.alert.type = ''
          }, this.alert.duration)
        }
      } catch (error) {
        this.alert.visible = true
        this.alert.message = 'Lỗi khi xác minh OTP'
        this.alert.type = 'error'
        this.alert.duration = 2000
        setTimeout(() => {
          this.alert.visible = false
          this.alert.message = ''
          this.alert.type = ''
        }, this.alert.duration)
      }
    },
    async datMatKhau() {
      if (
        !this.password ||
        !this.confirmPassword ||
        this.password !== this.confirmPassword
      ) {
        this.alert.visible = true
        this.alert.message = 'Mật khẩu không hợp lệ hoặc không khớp'
        this.alert.type = 'error'
        this.alert.duration = 2000
        setTimeout(() => {
          this.alert.visible = false
          this.alert.message = ''
          this.alert.type = ''
        }, this.alert.duration)

        return
      }
      try {
        //  console.log(this.phone)

        const headers = this.headers
        await this.$axios.post(
          `/set_hosoonline_password`,
          {
            p_phone: this.phone,
            p_temp_password: this.password,
          },
          {
            headers: {
              authorization: headers.authorization,
            },
          }
        )

        this.alert.visible = true
        this.alert.message = 'Đặt mật khẩu thành công!'
        this.alert.type = 'success'
        this.alert.duration = 2000
        setTimeout(() => {
          this.alert.visible = false
          this.alert.message = ''
          this.alert.type = ''
        }, this.alert.duration)
        await this.$axios.post(
          `/delete_phone_otp`,
          {
            p_phone: this.phone,
          },
          {
            headers: {
              authorization: headers.authorization,
            },
          }
        )
        this.get_person()
        //this.step = 'done' // bạn có thể điều hướng tới trang khác nếu cần
      } catch (error) {
        console.log(error)

        this.alert.visible = true
        this.alert.message = 'Lỗi khi đặt mật khẩu'
        this.alert.type = 'error'
        this.alert.duration = 2000
        setTimeout(() => {
          this.alert.visible = false
          this.alert.message = ''
          this.alert.type = ''
        }, this.alert.duration)
      }
    },
    // Hàm setItem có expire
    setItemWithExpire(key, value, ttl) {
      const now = Date.now()
      const item = {
        value: value,
        expiry: now + ttl, // ttl tính bằng ms
      }
      localStorage.setItem(key, JSON.stringify(item))
    },

    // Hàm getItem có expire
    getItemWithExpire(key) {
      const itemStr = localStorage.getItem(key)
      if (!itemStr) return null

      const item = JSON.parse(itemStr)
      const now = Date.now()

      if (now > item.expiry) {
        localStorage.removeItem(key) // hết hạn thì xóa
        return null
      }
      return item.value
    },
    async get_person() {
      try {
        const headers = this.headers
        const pv = await this.$axios.get(`/get_person`, {
          headers,
          params: { p_phone: this.phone },
        })

        this.listkhachhang = pv.data.data

        this.setItemWithExpire('phone', this.phone, 300000)
        this.setItemWithExpire('listkhachhang', this.listkhachhang, 300000)
        //  console.log(this.getItemWithExpire('phone'))

        if (pv.data.data && pv.data.data.length === 1) {
          //  console.log('có 1 khách')
          this.listkhachhang = pv.data.data[0]
          this.selectedPid = pv.data?.data?.pid
          this.$store.commit('setMayte', this.listkhachhang.mayte)
          //this.$store.commit('setHeaders', this.headers)
          // console.log(this.$store.state.mayte)
          this.$router.push('/main')
        } else {
          this.listkhachhang = pv.data.data
          this.$store.commit('setMayte', this.listkhachhang.mayte)
          // this.$store.commit('setHeaders', this.headers.authorization)
          //console.log(this.$store.state.mayte)
          this.step = 'chonpid'
        }
        //this.step = 'done' // bạn có thể điều hướng tới trang khác nếu cần
      } catch (error) {
        console.log(error)
      }
    },
    async dangNhap() {
      if (!this.password) {
        this.alert.visible = true
        this.alert.message = 'Vui lòng nhập mật khẩu'
        this.alert.type = 'error'
        this.alert.duration = 2000
        setTimeout(() => {
          this.alert.visible = false
          this.alert.message = ''
          this.alert.type = ''
        }, this.alert.duration)

        return
      }

      try {
        const headers = this.headers
        const login = await this.$axios.post(
          `/dangnhap_hosoonline_password`,
          {
            p_phone: this.phone,
            p_temp_password: this.password,
          },
          {
            headers: {
              authorization: headers.authorization,
            },
          }
        )
        //console.log(login.data.data[0])
        //console.log(this.phone)

        if (login.data.data[0]?.phone === this.phone) {
          this.get_person()
        }
        if (!login.data.data[0]?.phone) {
          this.alert.visible = true

          this.alert.message = 'Sai mật khẩu'
          this.alert.type = 'error'
          this.alert.duration = 2000

          setTimeout(() => {
            this.alert.visible = false
            this.alert.message = ''
            this.alert.type = ''
          }, this.alert.duration)
        }
      } catch (error) {
        console.log(error)

        this.alert.visible = true
        this.alert.message = 'Lỗi đăng nhập'
        this.alert.type = 'error'
        this.alert.duration = 2000
        setTimeout(() => {
          this.alert.visible = false
          this.alert.message = ''
          this.alert.type = ''
        }, this.alert.duration)
      }
    },
    goMain() {
      // đặt cookie visitedIndex = true
      document.cookie = 'visitedIndex=true; path=/'
      this.$router.push('/main')
    },
    formatDate(dateString) {
      const date = new Date(dateString)
      return date.toLocaleDateString('vi-VN')
    },

    async loadScheduleStatus() {
      try {
        const response = await this.$axios.get('/schedule-status')
        this.scheduleStatus = response.data
      } catch (error) {
        // Không hiển thị lỗi nếu không load được schedule status
        console.log('Không thể load schedule status:', error)
      }
    },
  },
}
